import { Booth } from '../../../../../../../../interfaces/interfaces';
import { BoothTotalContactShare } from '../../../../../../../account/Analytics/BoothTotalContactShare';
import { BoothBestPresentations } from './BoothBestPresentations';
import { BoothChatMessages } from './BoothChatMessages';
import { BoothImpressions } from './BoothImpressions';
import { BoothMeetingMinutes } from './BoothMeetingMinutes';
import { BoothPDFTracker } from './BoothPDFTracker';
import { BoothReportingStats } from './BoothReportingStats';
import { BoothVCardDownloads } from './BoothVCardDownloads';
import { BoothVideoViews } from './BoothVideoViews';

const BoothStats = ({ booth }: { booth: Booth }) => {
  return (
    <div className="flex-1 relative items-center flex-col justify-center">
      <div className=" flex flex-col @md:flex-row @md:space-x-4 space-y-4 @md:space-y-0">
        <BoothImpressions booth={booth} />
        <BoothChatMessages booth={booth} />
        <BoothTotalContactShare booth={booth} />
      </div>
      <BoothMeetingMinutes booth={booth} />
      <BoothPDFTracker booth={booth} />
      <BoothVideoViews booth={booth} />
      <BoothVCardDownloads booth={booth} />
      <BoothBestPresentations />
      <br />
      <BoothReportingStats booth={booth} />
    </div>
  );
};
export default BoothStats;
